export enum TaskStatusType {
    Undefined = 0,
    Todo = 1,
    Closed = 2,
    Overdue = 3
}
